import { server } from '../configuration';
import { Api } from './client';

const api = new Api(server, (url, init) => fetch(url, init));

export default api;
export { Api, normaliseMessages, SERVER_ERROR_PREFIX } from './client';
export type { Transport } from './client';
export * from './types';
